import 'media-chrome';  
import mux from '@mux/mux-video';

import 'lazysizes';

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Parallax, Mousewheel, EffectFade } from 'swiper/modules';

import Alpine from 'alpinejs'
import $ from 'jquery';

import gsap from 'gsap';

import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';


window.mediaController = document.querySelector('media-controller');

window.hideIntro;
window.$ = $;
window.introTl;
window.Alpine = Alpine

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.Autoplay = Autoplay;
window.EffectFade = EffectFade;

Alpine.store('data', {
  intro: true,
  about: false,
  index: false,
  showIframe: false,
  iframeSrc: '',
  pageSlug: '',
})


Alpine.start()
gsap.fromTo('body', {
  opacity: 0,
}, {
  opacity: 1,
  delay: 0.5,
  duration: 1,
});



function observeVideos() {
  // Get all video elements (both regular video and mux-video)
  const videos = document.querySelectorAll('video, mux-video');
  
  if (videos.length === 0) return;

  // Create the IntersectionObserver
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      
      if (entry.isIntersecting) {
        // Video is in viewport - play it
        video.play().catch(err => {
          // Handle autoplay restrictions
          console.log('Autoplay prevented:', err);
        });
      } else {
        // Video is out of viewport - pause it
        video.pause();
      }
    });
  }, {
    threshold: 0.5, // Trigger when 50% of the video is visible
    rootMargin: '0px' // No margin
  });

  // Observe all videos
  videos.forEach(video => {
    videoObserver.observe(video);
  });
}

function init(){

  Splitting();

  
  const container = window.innerWidth > 768 ? document.getElementById('home-video-container') : document.getElementById('home-mobile-video-container');
  const homeMuxVideo = container ? container.querySelector('mux-video') : null;


  introTl = gsap.timeline({paused: true});
  // Create a new timeline for the sentences


  // Get all sentence spans
  const sequences = document.querySelectorAll('.sequence-content');
  
  sequences.forEach(sequence => {

  const sequenceTl = gsap.timeline(); // -1 means infinite loop

  // get first span inside sequence
  const sentences = sequence.querySelectorAll('.words');

  introTl.to("body", {
    duration: 0.5,
    opacity: 1,
    delay: 1,
  })

  
  // First, set initial state for all sentences except the first one
  sentences.forEach((sentence, index) => {
   // if (index > 0) {
      gsap.set(sentence.querySelectorAll('.char'), {
        scaleY: 0,
        height: 0,
      });

      gsap.set(sentence.querySelectorAll('.whitespace'), {
        backgroundColor: "white",
      });
      
  });

  // Create the animation sequence
  sentences.forEach((sentence, index) => {
    sequenceTl.set(sentence.querySelectorAll('.whitespace'), {
      backgroundColor: "transparent",
      duration: 0.3,
      stagger: 0.02,
       ease: "steps(3)"
    }, "<");


    // Animate in the current sentence
    sequenceTl.to(sentence.querySelectorAll('.char'), {
      scaleY: 1,
      height: 'auto',
      duration: 0.3,
      stagger: 0.01,
       ease: "steps(3)"
    }, "<");

    // Hold the sentence for a moment




  });


  sentences.forEach(sentence => {
    var moTl = gsap.timeline({paused: true});

    moTl.set(sentence.querySelectorAll('.whitespace'), {
      backgroundColor: "transparent",
    });

    moTl.set(sentence.querySelectorAll('.char'), {
      scaleY: 1,
      delay: 1,
      height: "auto",
    });


    moTl.to(sentence.querySelectorAll('.char'), {
      scaleY: 0,
      height: 0,
      duration: 0.5,
      stagger: 0.01,
      ease: "steps(3)"
    });

    moTl.to(sentence.querySelectorAll('.whitespace'), {
      backgroundColor: "white",
      duration: 0.3,
      stagger: 0.01,
       ease: "steps(3)"
    }, "<");
    
    $(sentence).mouseenter(function(){
      if (!(Alpine.store('data').intro)){
        moTl.progress(0);
        moTl.pause();
      }
    });


    $(sentence).mouseleave(function(){
      if (!(Alpine.store('data').intro)){
        moTl.progress(0);
        moTl.play();
      }
    });
    
    if (!(Alpine.store('data').intro)){
      moTl.progress(0);
      moTl.play();
    }
    
  });

  introTl.add(sequenceTl, "<");

  });

  introTl.progress(0);
  introTl.play();

  hideIntro = gsap.timeline({paused: true});

  hideIntro.fromTo('.intro-container > span > span', {
    opacity: 1,
    }, {
    opacity: 0,
    duration: 0.7,
    stagger: {
      from: 'end',
      amount: 0.5,
    },
  });

  hideIntro.to('.intro-container', {
    opacity: 0,
    duration: 0.3,
    ease: "none",
    onStart: function(){
      $('.intro-container').css('pointer-events', 'none');
      // Emit custom event when intro is turned off
    },
    onComplete: function(){
      Alpine.store('data').intro = false;
    }
  });


  $('.intro-container').on('click', function(){
    // cancel introTL repeat
    introTl.progress(0);
    introTl.play();
    introTl.repeat(0);
    window.dispatchEvent(new CustomEvent('introComplete'));

    if (homeMuxVideo) {
      console.log(homeMuxVideo);
      const mediaControllers = document.querySelectorAll('media-controller');
      mediaControllers.forEach(controller => {
        controller.removeAttribute('userinactive');
      });
      homeMuxVideo.volume = 0.6;
      homeMuxVideo.muted = false;
      homeMuxVideo.currentTime = 0;
      homeMuxVideo.play();

      setTimeout(function(){
        mediaControllers.forEach(controller => {
          controller.setAttribute('userinactive', 'true');
        });
      }, 8000);
    }

    hideIntro.play();

  });

  $('.back-home').on('click', function(e){

    hideIntro.progress(0);
    hideIntro.pause();

    e.preventDefault();
    
    // Show intro again
    Alpine.store('data').intro = true;
    
    // Pause the video
    if (homeMuxVideo) {
      homeMuxVideo.pause();
      homeMuxVideo.muted = true;
    }
    
    // Also pause any videos in clock pages
    const clockVideos = document.querySelectorAll('.video-container video');
    clockVideos.forEach(v => v.pause());

    // Reset intro container styles and replay animation
    gsap.set('.intro-container', {
      opacity: 1,
      pointerEvents: 'auto'
    });
    
    gsap.set('.intro-container > span', {
      opacity: 1
    });
    
    // Replay the intro timeline
    if (introTl) {
      introTl.progress(0);
      introTl.play();
    }
  });


  // homeMuxVideo.on('ended', function(){
  //     // use swup to navigate to the index page
  //     swup.navigate('/index');
  // });

  if (homeMuxVideo) {
    console.log(homeMuxVideo);
    homeMuxVideo.addEventListener('ended', function(){
      console.log('ended');
      setTimeout( function(){
        swup.navigate('/index');
      },500)
});
  }

  // Initialize video viewport observer
  observeVideos();

}

init();

const swup = new Swup({
  containers: ["#swup"],
  native:false,
  animationSelector: false,
  plugins: [new SwupPreloadPlugin()]

});

swup.hooks.replace('animation:out:await', async () => {
  gsap.to('.transition-fade', { opacity: 0, duration: 0 });
});
swup.hooks.replace('animation:in:await', async () => {
  gsap.fromTo('.transition-fade', { opacity: 0 }, { opacity: 1, delay: 0.25, duration: 0.5 });
});


swup.hooks.on('page:view', (visit) => {
  init()
  introTl.progress(1);
  introTl.play();
  introTl.repeat(0);
});


